var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.25H3C1.625 0.25 0.5 1.375 0.5 2.75V20.25H3V2.75H18V0.25ZM21.75 5.25H8C6.625 5.25 5.5 6.375 5.5 7.75V25.25C5.5 26.625 6.625 27.75 8 27.75H21.75C23.125 27.75 24.25 26.625 24.25 25.25V7.75C24.25 6.375 23.125 5.25 21.75 5.25ZM21.75 25.25H8V7.75H21.75V25.25Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.658d4080e6f69beae8f67878ee1566b1.svg";
export { ForwardRef as ReactComponent };